function copyToClipboard(event) {
    event.preventDefault();
    // create hidden text element, if it doesn't already exist
    const elem = $(this);
    const urlToCopy = elem.attr('data-url');

    const _temporaryInput = $("<input>");
    elem.append(_temporaryInput);
    _temporaryInput.val( urlToCopy ).focus().select();

    let succeed;
    try {
        succeed = document.execCommand("copy");
    } catch(e) {

        console.log("Link copy failed, couldn't use the execCommand", e);

        const dialog = $(this).closest('.copy-link-dialog');
        const input = dialog.find('input');

        dialog.addClass('show');
        setTimeout(function() {
            dialog.addClass('open');
            input.focus();
            input.select();
        }, 10);

    }

    if(succeed) {
        const succeedTooltip = elem.find('.copy-link-dialog__success-message');
        succeedTooltip.addClass('show');
        setTimeout(function() {
            succeedTooltip.removeClass('show');
            _temporaryInput.remove();
            elem.focus();
        }, 2000);
    }
}

$(document).ready(function() {
    const copyButton = $('.copy-link-dialog');
    $(document).on("click", ".copy-link-dialog", copyToClipboard);

    if (copyButton.length > 0) {
        copyButton.attr("tabindex", "-1");
    }
});